import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Impressum() {
    const { useLang, isMobile, Link } = useGlobal();
    const { t } = useLang('impressum');

    return (
        <div className={`impressum ${css.impressum} ${isMobile ? 'impressum-h5' : ''}`}>
            <div className="title">{t('title')}</div>
            <div className="text-wrap">
                <p className="wrap-title">{t('website')}</p>
                <p className="wrap-desc">{t('website_desc')}</p>
            </div>
            <div className="text-wrap">
                <p className="wrap-title">{t('data_protection')}</p>
                <p className="wrap-desc">
                    {t.rich('data_protection_desc', {
                        link: (text: string) => (
                            <Link className="link" href="https://de.ecoflow.com/policies/privacy-policy">
                                {text}
                            </Link>
                        ),
                    })}
                </p>
            </div>
            <div className="text-wrap">
                <p className="wrap-title">{t('contact')}</p>
                <p className="wrap-desc">
                    {t.rich('contact_desc', {
                        email: (text: string) => (
                            <a href={`mailto:${text}`} target="_blank" rel="noreferrer">
                                {text}
                            </a>
                        ),
                    })}
                </p>
            </div>
        </div>
    );
}
